module.exports = __webpack_public_path__ + "static/media/user.fb22f620.svg";